import React, { useEffect, useState } from "react";
import { OrganizationDto } from "../../../common/service/server/dto/OrganizationDto";
import { OrganizationNameForm } from "./OrganizationNameForm";
import {
  CustomDomainStepByStepInstructions,
  VerifySubdomain,
} from "../get-compliant/privacy-center/WebsiteSetupPage";
import { PrivacyCenterDto } from "../../../common/service/server/dto/PrivacyCenterDto";
import { Loading } from "../../components";

export const OrganizationSettingsView = ({
  organization,
  updateOrganization,
  privacyCenter,
}: {
  organization: OrganizationDto;
  updateOrganization(values: any): void;
  privacyCenter: PrivacyCenterDto;
}) => {
  const [readyToRender, setReadyToRender] = useState(false);

  const [showStepByStepInstructions, setShowStepByStepInstructions] = useState(false);

  const [privacyCenterDomain, setPrivacyCenterDomain] = useState<string>("");
  useEffect(() => {
    if (!privacyCenter) {
      return;
    }

    if (privacyCenter?.domains?.length > 0) {
      setPrivacyCenterDomain(privacyCenter.domains[0].customDomain);
    } else {
      // show step-by-step instructions if no initial privacy center domain on page load
      setShowStepByStepInstructions(true);
    }

    setReadyToRender(true);
  }, [privacyCenter]);

  if (!readyToRender) {
    return <Loading />;
  }

  return (
    <div>
      <div className={"org-settings"}>
        <OrganizationNameForm organization={organization} updateOrganization={updateOrganization} />
      </div>
      <div className="tw-boundary">
        <div className="my-[32px]">
          <hr className="border-gray-200 max-w-[640px]" />
        </div>
        <div className="text-neutral-900 text-[18px] font-medium">Verify Subdomain</div>
        <div className="text-[14px] font-normal leading-[21px] text-neutral-700 mt-[4px] mb-[12px]">
          Follow the instructions below to set up your custom domain for your Privacy Center.
          <br />
          First time adding a subdomain?{" "}
          <a
            href="https://knowledge.truevault.com/article/212-how-to-set-up-a-custom-domain-using-a-cname"
            target="_blank"
            rel="noreferrer"
            className="text-primary-600 underline font-medium"
          >
            Here's a how-to guide.
          </a>
        </div>
        <VerifySubdomain
          privacyCenter={privacyCenter}
          privacyCenterDomain={privacyCenterDomain}
          setPrivacyCenterDomain={setPrivacyCenterDomain}
          inputWidth="w-[457px]"
          maxWidth="w-[640px]"
          onSuccess={() => setShowStepByStepInstructions(false)}
          onError={() => setShowStepByStepInstructions(true)}
        />
        {showStepByStepInstructions && (
          <div className="mt-[12px] pl-[24px] max-w-[640px]">
            <CustomDomainStepByStepInstructions
              privacyCenter={privacyCenter}
              stepNumberBgColor="bg-neutral-200"
              stepNumberTextColor="text-neutral-700"
            />
          </div>
        )}
        <div className="my-[32px]">
          <hr className="border-gray-200 max-w-[640px]" />
        </div>
      </div>
    </div>
  );
};
